import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import portugueseBrazilian from "./pt-BR";
import englishUs from "./en-US";
import spanish from "./es";

const resources = {
  en: { ...englishUs },
  pt: { ...portugueseBrazilian },
  es: { ...spanish }
};

function i18nInit() {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: navigator.language,
      interpolation: {
        escapeValue: false
      }
    });

  /** Keeps <html lang> in sync with the active language, so the browser never
   * mistakes the page for another idiom and offers to machine-translate it. */
  i18n.on("languageChanged", (language) => {
    document.documentElement.lang = language;
  });

  document.documentElement.lang = i18n.language;
}

export default i18nInit;
